import React from 'react'

import { BrandList } from './globals';
import { tokens } from '../public/tokens';

const { colors } = tokens;

const stc = require('string-to-color');

// only for Learning Method or Study Type
export const RenderLearningMethod = (data, origin) => {
  switch (data ? data.toString().replace("-", "").replace(" ", "").toLowerCase() : "") {
    case "full":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "fulltimeonline":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "part":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "parttime":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "fulltimecontact":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "parttimeonline":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "selfplaced":
    return UIRender({ color: "cat-red", text: "Self-Paced", type: "learning method", origin });
    case "part_time_online":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "full_time_online":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "full_time_hybrid":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "cores":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "correspondence":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "correspondence", origin });
    case "online":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "part time":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "2":
    return UIRender({ color: "cat-green", text: "Diploma", type: "learning method", origin });
    case "diploma":
    return UIRender({ color: "cat-green", text: "Diploma", type: "learning method", origin });
    case "4":
    return UIRender({ color: "cat-orange", text: "Bachelor’s Degree", type: "learning method", origin });
    case "bachelor’sdegree":
    return UIRender({ color: "cat-orange", text: "Bachelor’s Degree", type: "learning method", origin });
    case "5":
    return UIRender({ color: "cat-skyblue", text: "Honours Degree", type: "learning method", origin });
    case "honoursdegree":
    return UIRender({ color: "cat-skyblue", text: "Honours Degree", type: "learning method", origin });
    case "3":
    return UIRender({ color: "cat-red", text: "Higher Certificate", type: "learning method", origin });
    case "highercertificate":
    return UIRender({ color: "cat-red", text: "Higher Certificate", type: "learning method", origin });
    case "7":
    return UIRender({ color: "cat-purple", text: "Learning Path", type: "learning method", origin });
    case "learningpath":
    return UIRender({ color: "cat-purple", text: "Learning Path", type: "learning method", origin });
    case "8":
    return UIRender({ color: "cat-red", text: "Occupational Certificate", type: "learning method", origin });
    case "occupationalcertificate":
    return UIRender({ color: "cat-red", text: "Occupational Certificate", type: "learning method", origin });
    case "6":
    return UIRender({ color: "cat-brown", text: "Master’s Degree" , type: "learning method", origin });
    case "master’sdegree":
    return UIRender({ color: "cat-brown", text: "Master’s Degree" , type: "learning method", origin });
    case "scheduled":
    return UIRender({ color: "cat-lightblue", text: "Instructor-Led" , type: "learning method", origin });
    case "mentored":
    return UIRender({ color: "cat-brown", text: "Mentored" , type: "learning method", origin });
    case "selfpaced":
    return UIRender({ color: "cat-red", text: "Self-Paced" , type: "learning method", origin });
    default:
    return UIRender({ color: "N/A", text: "-", type: "learning method", origin });
  }
};

//course Delivery 
export const RenderDeliveryMethod = (data, origin) => {
  switch (data ? data.toString().replace("-", "").replace(" ", "").toLowerCase() : "") {
    case "scheduled":
    return UIRender({ color: "cat-blue", text: "Instructor-Led Classes", type: "delivery method", origin });
    case "mentored":
    return UIRender({ color: "cat-yellow", text: "Mentored", type: "delivery method", origin });
    case "selfpaced":
    return UIRender({ color: "textdanger", text: "Self-paced", type: "delivery method", origin });
    default:
    return UIRender({ color: "N/A", text: "-", type: "delivery method", origin });
  }
};

export const RenderRelationship = (data, origin) => {
  switch (data ? data.toString().replace("-", "").replace(" ", "").toLowerCase() : "") {
    case "student":
    return UIRender({ color: "cat-blue", text: "Student", type: "relationship", origin });
    case "guardian":
    return UIRender({ color: "cat-purple", text: "Guardian", type: "relationship", origin });
    case "sponsor":
    return UIRender({ color: "cat-green", text: "Sponsor", type: "relationship", origin });
    case "employee":
    return UIRender({ color: "cat-yellow", text: "Employee", type: "relationship", origin });
    case "1":
    return UIRender({ color: "cat-blue", text: "Student", type: "relationship", origin });
    case "4":
    return UIRender({ color: "cat-purple", text: "Guardian", type: "relationship", origin });
    case "2":
    return UIRender({ color: "cat-green", text: "Sponsor", type: "relationship", origin });
    case "3":
    return UIRender({ color: "cat-yellow", text: "Employee", type: "relationship", origin });
    default:
    return UIRender({ color: "N/A", text: data.toString(), type: "relationship", origin });
  }
};
export const RenderBookingState = (data, origin) => {
  
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "3":
    return UIRender({ color: "cat-red", text: "Active-Closed", type: "state", origin });
    case "1":
    return UIRender({ color: "cat-green", text: "Active-Open", type: "state", origin });
    case "4":
    return UIRender({ color: "cat-blue", text: "Active-Delivered", type: "state", origin });
    case "2":
    return UIRender({ color: "red", text: "Cancelled", type: "state", origin });
    default:
    return UIRender({ color: "N/A", text: data, type: "state", origin });
  }
};

export const RenderSoftphoneType = (data, origin) => {
  
  switch (data != null && data != undefined ? data.toString().replace("-", "").toLowerCase() : "") {
    case "1":
    return UIRender({ color: "cat-outgoing", text: "Outgoing", type: "type", origin })
    case "3":
    return UIRender({ color: "cat-missed", text: "Missed", type: "type", origin })
    case "2":
    return UIRender({ color: "cat-incoming", text: "Incoming", type: "type", origin })
    case "4":
    return UIRender({ color: "cat-purple", text: "Declined", type: "type", origin })
    default:
    return UIRender({ color: "N/A", text: data, type: "state", origin });
  }
}
export const RenderLearningMethodGradebook = (data, origin) => {
  
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "1":
      return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "2":
       return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "3":
      return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "4":
       return UIRender({ color: "cat-red", text: "Self-Paced", type: "learning method", origin });
    case "full":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "fulltimeonline":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "part":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "parttime":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "fulltimecontact":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "parttimeonline":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "selfplaced":
    return UIRender({ color: "cat-red", text: "Self-Paced", type: "learning method", origin });
    case "part_time_online":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "full_time_online":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "full_time_hybrid":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "learning method", origin });
    case "cores":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    case "correspondence":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "correspondence", origin });
    case "online":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "learning method", origin });
    case "part time":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "learning method", origin });
    default:
    return UIRender({ color: "N/A", text: "-", type: "learning method", origin });
  }
};
export const RenderFeatureAndBenefits = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "program":
    return UIRender({ color: "skyblue", text: "Program", type: "features And Benefits", origin });
    case "institute":
    return UIRender({ color: "red", text: "Institute", type: "features And Benefits", origin });
    case "faculty":
    return UIRender({ color: "green", text: "Faculty", type: "features And Benefits", origin });
    default:
    return UIRender({ color: "NA", text: "-", type: "features And Benefits" });
  }
};

// Only for list with course and programme options, DON'T ADD ANY OTHER OPTION
export const RenderSLP = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "programs":
    return UIRender({ color: "cat-blue", text: "Programs", type: "slp", origin });
    case "shortcourse":
    return UIRender({ color: "cat-yellowshade", text: "Course", type: "slp", origin });
    default:
    return UIRender({ color: "NA", text: "-", type: "slp" });
  }
};
export const MappingSchool = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "visual_design":
    return "School of Visual Design, Marketing & Branding";
    case "draughting":
    return "School of Draughting & Technical Design";
    case "it":
    return "School of Information Technology & Data Science";
    case "engineering":
    return "School of Engineering & Science";
    case "business":
    return "School of Business, Entrepreneurship & Finance";
    case "architecture":
    return "School of Architecture & The Built Environment";
    case "gdc":
    return "Greenside Design Center";
    case "school of draughting & technical design":
    return "School of Draughting & Technical Design";
    case "school of engineering & science":
    return "School of Engineering & Science";
    case "school of business, entrepreneurship & finance":
    return "School of Business, Entrepreneurship & Finance";
    case "school of architecture & the built environment":
    return "School of Architecture & The Built Environment";
    case "greenside design center":
    return "Greenside Design Center";
    case "fg":
    return "School of Game Design & Development";
    case "fst":
    return "School of Music & Sound Production";
    case "School of Game Design & Development":
    return "School of Game Design & Development";
    case "School of Music & Sound Production":
    return "School of Music & Sound Production";
    case "beauty":
    return "School of Beauty and Health Science";
    case "artisans":
    return "School of Artisans, Trades and Professions";
    default:
    return "--"
  }
}
// Only For School Type
// AIE brands each school with a colour from the token ramp. The nine primary
// schools sit at step 500 and the three secondary ones at 400.
const schoolBranding = {
  visual_art: { text: "School of Art & Design", hue: "veld-sprout", step: "500" },
  visual_design: { text: "School of Visual Design, Marketing & Branding", hue: "burnt-orange", step: "400" },
  draughting: { text: "School of Draughting & Technical Design", hue: "fresh-green", step: "500" },
  it: { text: "School of Information Technology & Data Science", hue: "naartjie", step: "500" },
  engineering: { text: "School of Engineering & Science", hue: "karoo-gold", step: "500" },
  business: { text: "School of Business, Entrepreneurship & Finance", hue: "burnt-orange", step: "500" },
  architecture: { text: "School of Architecture & The Built Environment", hue: "blue", step: "500" },
  gdc: { text: "Greenside Design Center", hue: "veld-sprout", step: "400" },
  // fg and fst are the legacy slugs for Game Design and Music & Sound.
  fg: { text: "School of Game Design & Development", hue: "tide-blue", step: "400" },
  fst: { text: "School of Music & Sound Production", hue: "tide-blue", step: "500" },
  beauty: { text: "School of Beauty and Health Science", hue: "plum-orchid", step: "500" },
  artisans: { text: "School of Artisans, Trades and Professions", hue: "red", step: "500" },
};

// Some records carry the school's full display name instead of its slug.
const schoolAliases = {
  "school of draughting": "draughting",
  "school of draughting & technical design": "draughting",
  "school of engineering and science": "engineering",
  "school of engineering & science": "engineering",
  "school of business & finance": "business",
  "school of business, entrepreneurship & finance": "business",
  "school of architecture": "architecture",
  "school of architecture & the built environment": "architecture",
  "school of art and design": "visual_art",
  "school of art & design": "visual_art",
  "school of visual design, marketing & branding": "visual_design",
  "school of information technology": "it",
  "school of information technology & data science": "it",
  "school of game design & development": "fg",
  "school of music & sound": "fst",
  "school of music & sound production": "fst",
  "school of beauty": "beauty",
  "school of beauty and health science": "beauty",
  "school of artisans": "artisans",
  "school of artisans, trades and professions": "artisans",
  "greenside design center": "gdc",
};

/**
 * Renders a school with its AIE brand colour.
 * @param {string} data School slug, or the school's full display name
 * @param {string} origin Set to truthy to truncate the label
 * @returns Render object with the brand hex as `color`
 */
export function RenderSchool(data, origin) {
  const key = data ? data.toString().replace("-", "").toLowerCase() : "";
  const branding = schoolBranding[key] || schoolBranding[schoolAliases[key]];

  if (!branding) {
    return UIRender({ color: colors.text.secondary, text: "--", type: "school", origin });
  }

  return UIRender({
    color: colors.brand[branding.hue][branding.step],
    text: branding.text,
    type: "school",
    origin,
  });
}
export const RenderEnableStudyPath = (data, origin) => {
  if(data == 1){
    return <div className='d-flex items cat'><span className='cat istyle as-widget no-text-transformation mr-2'><i class="fal fa-check check-true mr-1"></i></span></div>
  }else if(data == 0){
    return <div className='d-flex items cat'><span className='cat istyle as-widget no-text-transformation mr-2'><i class="fal fa-times no-cross mr-1"></i></span></div>
  }else{
    return <div className='d-flex items cat'><span>{data}</span></div>
  }
}


//Only for Progromme Type
export const RenderProgrammeType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "online":
    return UIRender({
      color: "cat-yellowshade",
      text: "Online",
      type: "programme",
      origin,
    });
    
    case "diploma":
    return UIRender({
      color: "cat-green",
      text: "Diploma",
      type: "programme",
      origin,
    });
    
    case "1":
    return UIRender({
      color: "cat-blue",
      text: "Certificate",
      type: "programme",
      origin,
    });
    
    case "2":
    return UIRender({
      color: "cat-green",
      text: "Diploma",
      type: "programme",
      origin,
    });
    
    case "3":
    return UIRender({
      color: "cat-red",
      text: "Higher Certificate",
      type: "programme",
      origin,
    });
    
    case "4":
    return UIRender({
      color: "cat-orange",
      text: "Bachelor’s Degree",
      type: "programme",
      origin,
    });
    case "bachelor’s degree":
    return UIRender({ color: "cat-orange", text: "Bachelor’s Degree", type: "learning method", origin });
    case 'national certificate':
    return UIRender({color: 'cat-blue',text: "National Certificate", type: "programme", origin})
    
    case "5":
    return UIRender({
      color: "cat-skyblue",
      text: "Honours Degree",
      type: "programme",
      origin,
    });
    case "honours degree":
    return UIRender({
      color: "cat-skyblue",
      text: "Honours Degree",
      type: "programme",
      origin,
    });
    
    case "6":
    return UIRender({ color: "cat-brown", text: "Master’s Degree", type: "programme", origin });
    case "master’s degree":
    return UIRender({ color: "cat-brown", text: "Master’s Degree", type: "programme", origin });
    case "7":
    return UIRender({ color: "cat-purple", text: "Learning Path", type: "programme", origin });
    case "learning path":
    return UIRender({ color: "cat-purple", text: "Learning Path", type: "programme", origin });
    case "8":
    return UIRender({
      color: "cat-red",
      text: "Occupational Certificate",
      type: "programme",
      origin,
    });
    case "occupational certificate":
    return UIRender({
      color: "cat-red",
      text: "Occupational Certificate",
      type: "programme",
      origin,
    });
    case "certificate":
    return UIRender({
      color: "cat-green",
      text: "Certificate",
      type: "programme",
      origin,
    });
    
    case "higher certificate":
    return UIRender({
      color: "cat-red",
      text: "Higher Certificate",
      type: "programme",
      origin,
    });
    
    case "honours degree":
    return UIRender({
      color: "cat-green",
      text: "Honours Degree",
      type: "programme",
      origin,
    });
    
    case "master'sDegree":
    return UIRender({
      color: "cat-green",
      text: "Masters Degree",
      type: "programme",
      origin,
    });

    case "0":
    return UIRender({
      color: "cat-purple",
      text: "Short Course",
      type: "programme",
      origin,
    });
    
    default:
    return UIRender({
      color: "cat-green",
      text: "Masters Degree",
      type: "programme",
      origin,
    });
  }
};

export const RenderTypeOfProgramme = (data) => {
  return UIRender({ data, type: "programme", origin });
};

//Only for Course Type
export const RenderCourseType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "scheduled":
    return UIRender({ color: "cat-blue", text: "Academic", type: "course type", origin });
    
    case "mentored":
    return UIRender({ color: "cat-blue", text: "Academic", type: "course type", origin });
    
    case "information":
    return UIRender({ color: "cat-blue", text: "Academic", type: "course type", origin });
    
    case "orientation":
    return UIRender({ color: "cat-green", text: "Orientation", type: "course type", origin });
    
    case "shortcourse":
    return UIRender({ color: "cat-yellow", text: "SLP", type: "course type", origin });
    
    case "short course":
    return UIRender({ color: "cat-yellow", text: "SLP", type: "course type", origin });
    
    case "rereg_shortcourse":
    return UIRender({ color: "cat-yellow", text: "Course", type: "course type", origin });
    
    default:
    return UIRender({ color: "NA", text: "-", type: "course type" });
  }
};



// only for Correspondence
export const RenderCorrespondence = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "full":
    return UIRender({ color: "cat-skyblue", text: "Full-Time, Hybrid", type: "correspondence", origin });
    case "fulltime":
    return UIRender({ color: "cat-skyblue", text: "Full-Time, Hybrid", type: "correspondence", origin });
    case "part":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "correspondence", origin });
    case "parttime":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "correspondence", origin });
    case "fulltimecontact":
    return UIRender({ color: "cat-skyblue", text: "Full Time, Hybrid", type: "correspondence", origin });
    case "parttimeonline":
    return UIRender({ color: "cat-blue", text: "Part-Time, Online", type: "correspondence", origin });
    case "cores":
    return UIRender({ color: "cat-blue", text: "Part Time, Online", type: "correspondence", origin });
    case "fulltimeonline":
    return UIRender({ color: "cat-lightblue", text: "Full Time, Online", type: "correspondence", origin });
    case "selfplaced":
    return UIRender({ color: "cat-red", text: "Self-Paced", type: "learning method", origin });
    default:
    return UIRender({ color: "NA", text: "-", type: "correspondence" });
  }
};
//only for registration list type
export const RenderStudentType = (data) => {
  switch (data) {
    case "south-african-citizen":
    return UIRender({ color: "cat-skyblue", text: "South African Citizen", type: "studentType" });
    case "international-student":
    return UIRender({ color: "cat-red", text: "International Student", type: "studentType" });
    default:
    return UIRender({ color: "black", text: "N/A", type: "studentType" });
  }
};

// only for programme or course type
export const RenderProgrammeOrCourseType = (data, origin) => {
  switch (data) {
    case "shortcourse":
    return UIRender({ color: "cat-yellowshade", text: "Course", type: "proogrammeOrCourseType", origin });
    case "programs":
    return UIRender({ color: "cat-blue", text: "Programs", type: "proogrammeOrCourseType", origin });
    case "1":
    return UIRender({ color: "cat-yellowshade", text: "Course", type: "proogrammeOrCourseType", origin });
    case "0":
    return UIRender({ color: "cat-blue", text: "Programs", type: "proogrammeOrCourseType", origin });
    case 1:
    return UIRender({ color: "cat-yellowshade", text: "Course", type: "proogrammeOrCourseType", origin });
    case 0:
    return UIRender({ color: "cat-blue", text: "Programs", type: "proogrammeOrCourseType", origin });
    default:
    return UIRender({ color: "NA", text: "-", type: "proogrammeOrCourseType" });
  }
};

//only for Ticket Level
export const RenderTicketLevel = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "1":
    return UIRender({ color: "cat-green", text: "1", type: "ticketLevel", origin });
    case "2":
    return UIRender({ color: "cat-blue", text: "2", type: "ticketLevel", origin });
    case "3":
    return UIRender({ color: "cat-yellow", text: "3", type: "ticketLevel", origin });
    case "4":
    return UIRender({ color: "cat-red", text: "4", type: "ticketLevel", origin });
    default:
    return UIRender({ color: "NA", text: "-", type: "ticketLevel" });
  }
};


//only for Status in pmc table
export const RenderPMCStatus = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "new":
    return UIRender({ color: "skyblue", text: "New", type: "pmcStatus", backgroundColorHex: "#e0ffff", colorHex: "#40e0d0", origin });
    case "draft":
    return UIRender({ color: "red", text: "Draft", type: "pmcStatus", backgroundColorHex: "#ffaaaa", colorHex: "#ff0000", origin });
    case "final":
    return UIRender({ color: "green", text: "Final", type: "pmcStatus", backgroundColorHex: "#d5ffd9", colorHex: "#00c915", origin });
    case "approved":
    return UIRender({ color: "yellowshade", text: "Approved", type: "pmcStatus", backgroundColorHex: "#e7e8d7", colorHex: "#abb072", origin });
    case "inactive":
    return UIRender({ color: "blue", text: "Inactive", type: "pmcStatus", backgroundColorHex: "#e0edff", colorHex: "#1899d2", origin });
    case "active":
    return UIRender({ color: "blue", text: "Inactive", type: "pmcStatus", backgroundColorHex: "#e0edff", colorHex: "#1899d2", origin });
    default:
    return UIRender({ color: "black", text: "N/A", type: "pmcStatus" });
  }
};

//only for Status in quiz table
export const RenderQuizStatus = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "new":
    return UIRender({ color: "skyblue", text: "New", type: "quiz", backgroundColorHex: "#e0ffff", colorHex: "#40e0d0", origin });
    case "draft":
    return UIRender({ color: "red", text: "Draft", type: "quiz", backgroundColorHex: "#ffaaaa", colorHex: "#ff0000", origin });
    case "active":
    return UIRender({ color: "green", text: "Active", type: "quiz", backgroundColorHex: "#d5ffd9", colorHex: "#00c915", origin });
    case "inactive":
    return UIRender({ color: "blue", text: "Inactive", type: "quiz", backgroundColorHex: "#e0edff", colorHex: "#1899d2", origin });
    default:
    return UIRender({ color: "black", text: "N/A", type: "quiz" });
  }
};
export const RenderModuleStatus = (data, origin) => {
  switch (data) {
    
    case "New":
    return UIRender({ color: "skyblue", text: "NEW", type: "backgroundColorOnly", backgroundColorHex: "#e0ffff", colorHex: "#40e0d0", origin });
    case "Draft":
    return UIRender({ color: "red", text: "DRAFT", type: "backgroundColorOnly", backgroundColorHex: "#ffaaaa", colorHex: "#ff0000", origin });
    case "Final":
    return UIRender({ color: "green", text: "FINAL", type: "backgroundColorOnly", backgroundColorHex: "#d5ffd9", colorHex: "#00c915", origin });
    case "Approved":
    return UIRender({ color: "yellowshade", text: "APPROVED", type: "backgroundColorOnly", backgroundColorHex: "#e7e8d7", colorHex: "#abb072", origin });
    case "Inactive":
    return UIRender({ color: "blue", text: "INACTIVE", type: "backgroundColorOnly", backgroundColorHex: "#e0edff", colorHex: "#1899d2", origin });
    case "NewAvailable":
    return UIRender({ color: "skyblue", text: "NEW", type: "backgroundColorOnly", backgroundColorHex: "#e0ffff", colorHex: "#40e0d0", origin });
    case "DraftAvailable":
    return UIRender({ color: "red", text: "DRAFT", type: "backgroundColorOnly", backgroundColorHex: "#ffaaaa", colorHex: "#ff0000", origin });
    case "FinalAvailable":
    return UIRender({ color: "green", text: "FINAL", type: "backgroundColorOnly", backgroundColorHex: "#d5ffd9", colorHex: "#00c915", origin });
    case "ApprovedAvailable":
    return UIRender({ color: "yellowshade", text: "APPROVED", type: "backgroundColorOnly", backgroundColorHex: "#e7e8d7", colorHex: "#abb072", origin });
    case "InactiveAvailable":
    return UIRender({ color: "blue", text: "INACTIVE", type: "backgroundColorOnly", backgroundColorHex: "#e0edff", colorHex: "#1899d2", origin });
    default:
    return UIRender({ color: "black", text: data.toUpperCase(), type: "backgroundColorOnly" });
  }
};
export const RenderBookingActiveStatus = (data) => {
  switch (data) {
    case "Active":
    return <p className="as-green-bg as-widget">Active</p>;
    case "Active-Rescheduled":
    return <p className="as-brown-bg as-widget">Active-Rescheduled</p>;
    case "Active-Retrain":
    return <p className="as-blue-bg as-widget">Active-Retrain</p>;
    case "Cancelled":
    return <p className="as-red-bg as-widget">Cancelled</p>;
    default:
    return <p className="as-black-bg as-widget">data</p>;
  }
};

export const RenderDelegateType = (data) => {
  switch (data) {
    case "In Class Attendee":
    return <p className="as-green-bg as-widget">In Class Attendee</p>;
    case "Virtual Attendee":
    return <p className="as-purple-bg as-widget">Virtual Attendee</p>;
    default:
    return <p className="as-black-bg as-widget">data</p>;
  }
};

export const RenderDelegateStatus = (data) => {
  switch (data) {
    case "Final":
    return <p className="as-green-bg as-widget">Final</p>;
    case "Preliminary":
    return <p className="as-red-bg as-widget">Preliminary</p>;
    default:
    return <p className="as-black-bg as-widget">data</p>;
  }
};

export const RenderDelegateLaptopType = (data) => {
  switch (data) {
    case "Fascility equipment to be provided":
    return <p className="as-green-bg as-widget">Facility to provide equipment</p>;
    case "Facility equipment to be provided":
    return <p className="as-green-bg as-widget">Facility to provide equipment</p>;
    case "Using own personal  laptop":
    return <p className="as-purple-bg as-widget">Using personal laptop</p>;
    default:
    return <p className="as-black-bg as-widget">{data}</p>;
  }
};

export const RenderITSetup = (data) => {
  switch (data) {
    case "Pending":
    return <p className="as-red-bg as-widget">Pending</p>;
    case "Setup Complete":
    return <p className="as-green-bg as-widget">Setup Complete</p>;
    case "Not Required":
    return <p className="as-purple-bg as-widget">Not Required</p>;
    default:
    return <p className="as-black-bg as-widget">{data}</p>;
  }
};
export const RenderCateringSetup = (data) => {
  switch (data) {
    case "Pending":
    return <p className="as-red-bg as-widget">Pending</p>;
    case "Catering Complete":
    return <p className="as-green-bg as-widget">Catering Complete</p>;
    case "Not Required":
    return <p className="as-purple-bg as-widget">Not Required</p>;
    default:
    return <p className="as-black-bg as-widget">{data}</p>;
  }
};

export const RenderCreditBearing = (data) => {
  switch (data) {
    case "Yes":
    return <p className="as-green-bg as-widget">Yes</p>;
    case "No":
    return <p className="as-red-bg as-widget">No</p>;
    case 1:
    return <p className="as-green-bg as-widget">YES</p>;
    case 0:
    return <p className="as-red-bg as-widget">NO</p>;
    default:
    return <p className="as-black-bg as-widget">data</p>;
  }
};
// Only for Type in Module, There are Two Different Type of type in Module, PMC
export const RenderTypeInModule = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "core":
    return UIRender({ color: "skyblue", text: "Core", type: "typeInModule", origin });
    case "specialised":
      return UIRender({ color: "red", text: "Specialised", type: "typeInModule", origin });
    case "nobarring":
      return UIRender({ color: "blue", text: "Non-Credit Bearing", type: "typeInModule", origin });
    case "foundation":
      return UIRender({ color: "yellowshade", text: "Foundation", type: "typeInModule", origin });
    default:
    return UIRender({ color: "black", text: "N/A", type: "typeInModule" });
  }
};

// Only for ModuleType, There are Two Different Type of type in Module, PMC
export const RenderModuleType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "information":
    return UIRender({ color: "cat-skyblue", text: "Information", type: "ModuleType", origin });
    case "mentored":
    return UIRender({ color: "cat-red", text: "Mentored", type: "ModuleType", origin });
    case "orientation":
    return UIRender({ color: "cat-green", text: "Orientation", type: "ModuleType", origin });
    case "scheduled":
    return UIRender({ color: "cat-yellowshade", text: "Scheduled", type: "ModuleType", origin });
    case "shortcourse":
    return UIRender({ color: "cat-blue", text: "Course", type: "ModuleType", origin });
    default:
    return UIRender({ color: "cat-black", text: "N/A", type: "ModuleType" });
  }
};

// Only for ModuleType, There are Two Different Type of type in Module, PMC
export const RenderModuleTerm = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "term1":
    return UIRender({ color: "skyblue", text: "Term1", type: "ModuleTerm", origin });
    case "term2":
    return UIRender({ color: "red", text: "Term1", type: "ModuleTerm", origin });
    case "term3":
    return UIRender({ color: "green", text: "Term1", type: "ModuleTerm", origin });
    case "term4":
    return UIRender({ color: "blue", text: "Term1", type: "ModuleTerm", origin });
    default:
    return UIRender({ color: "black", text: "N/A", type: "ModuleTerm" });
  }
};

// Only for Type in Assessment
export const RenderAssessmentType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {

    case "0":
      return UIRender({ color: "cat-red", text: "External Exam", type: "AssessmentType", origin });
    case "1": 
      return UIRender({ color: "cat-skyblue", text: "Assignment", type: "AssessmentType", origin });
    case "2":
      return UIRender({ color: "cat-green", text: "Internal Exam", type: "AssessmentType", origin });
    case "3":
      return UIRender({ color: "cat-brown", text: "Test", type: "AssessmentType", origin });
    case "4":
      return UIRender({ color: "cat-blue", text: "PoE-Formative", type: "AssessmentType", origin });
    case "5":
      return UIRender({ color: "cat-yellowshade", text: "PoE-Informal Activities", type: "AssessmentType", origin });
    case "6":
      return UIRender({ color: "cat-yellow", text: "PoE-Summative", type: "AssessmentType", origin });
    case "7":
      return UIRender({ color: "cat-purple", text: "Survey", type: "AssessmentType", origin });
    case "8":
      return UIRender({ color: "cat-blueshade", text: "Supplementary Exam", type: "AssessmentType", origin });
    case "9":
      return UIRender({ color: "cat-greenhex", text: "Sick Test", type: "AssessmentType", origin });
    case "10":
      return UIRender({ color: "cat-yellow", text: "KM Exam", type: "AssessmentType", origin });
    case "11":
      return UIRender({ color: "cat-red", text: "PM Exam", type: "AssessmentType", origin });
    case "12":
      return UIRender({ color: "cat-yellow", text: "Special Exam", type: "AssessmentType", origin });

    case "km exam":
      return UIRender({ color: "cat-yellow", text: "KM Exam", type: "AssessmentType", origin });
    case "pm exam":
      return UIRender({ color: "cat-red", text: "PM Exam", type: "AssessmentType", origin });
    case "special exam":
      return UIRender({ color: "cat-yellow", text: "Special Exam", type: "AssessmentType", origin });
    case "sick test":
      return UIRender({ color: "cat-greenhex", text: "Sick Test", type: "AssessmentType", origin });
    case "assignment":
      return UIRender({ color: "cat-skyblue", text: "Assignment", type: "AssessmentType", origin });
    case "external exam":
      return UIRender({ color: "cat-red", text: "External Exam", type: "AssessmentType", origin });
    case "internal exam":
      return UIRender({ color: "cat-green", text: "Internal Exam", type: "AssessmentType", origin });
    case "poeformative":
      return UIRender({ color: "cat-blue", text: "PoE-Formative", type: "AssessmentType", origin });
    case "scheduled":
      return UIRender({ color: "cat-green", text: "Scheduled", type: "course type", origin });
    case "mentored":
      return UIRender({ color: "cat-blue", text: "Mentored", type: "course type", origin });
    case "information":
      return UIRender({ color: "cat-red", text: "Information", type: "course type", origin });
    case "supplementary exam":
      return UIRender({ color: "cat-blueshade", text: "Supplementary Exam", type: "AssessmentType", origin });
    case "orientation":
      return UIRender({ color: "cat-brown", text: "Orientation", type: "course type", origin });
    case "shortcourse":
      return UIRender({ color: "cat-yellow", text: "Course", type: "course type", origin });
    case "poeinformal activities":
      return UIRender({ color: "cat-yellowshade", text: "PoE-Informal Activities", type: "AssessmentType", origin });
    case "short course":
      return UIRender({ color: "cat-yellow", text: "Course", type: "course type", origin });
    case "rereg_shortcourse":
      return UIRender({ color: "cat-yellow", text: "Course", type: "course type", origin });
    case "survey":
      return UIRender({ color: "cat-purple", text: "Survey", type: "AssessmentType", origin });
    case "poesummative":
      return UIRender({ color: "cat-yellow", text: "PoE-Summative", type: "AssessmentType", origin });
    case "test":
      return UIRender({ color: "cat-brown", text: "Test", type: "AssessmentType", origin });
    case "hybrid":
      return UIRender({ color: "cat-pinkhex", text: "Hybrid", type: "AssessmentType", origin });
    case "smart":
      return UIRender({ color: "cat-blue-heptica", text: "Smart Assessment", type: "AssessmentType", origin });
    case "document":
      return UIRender({ color: "cat-green-nature", text: "Document", type: "AssessmentType", origin });

    default:
      return UIRender({ color: "cat-red", text: "External Exam", type: "AssessmentType", origin });
  }
};

// Only for Laptop Spec
export const RenderLaptopSpec = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "basic_laptop":
    return UIRender({ color: "cat-skyblue", text: "Basic Spec Laptop", type: "laptopSpec", origin });
    case "high_laptop":
    return UIRender({ color: "cat-red", text: "High Spec Laptop", type: "laptopSpec", origin });
    case "medium_laptop":
    return UIRender({ color: "cat-green", text: "Medium Spec Laptop", type: "laptopSpec", origin });
    case "no_laptop":
    return UIRender({ color: "cat-blue", text: "No Laptop Required", type: "laptopSpec", origin });
    default:
    return UIRender({ color: "cat-black", text: "N/A", type: "laptopSpec" });
  }
};

// Only for Campus
export const RenderCampus = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {

    case "capetown":
      return UIRender({ color: "cat-skyblue", text: "Cape Town", type: "Campus", origin });
    case "cape town":
      return UIRender({ color: "cat-skyblue", text: "Cape Town", type: "Campus", origin });
    case "centpre":
      return UIRender({ color: "cat-red", text: "Centurion, Pretoria", type: "Campus", origin });
    case "correspondence":
      return UIRender({ color: "cat-green", text: "Correspondence", type: "Campus", origin });
    case "gdc":
    case "gdcb":
      return UIRender({ color: "cat-blue", text: "Greenside", type: "Campus", origin });
    case "greenside campus":
      return UIRender({ color: "cat-blue", text: "Greenside", type: "Campus", origin });
    case "Greenside":
      return UIRender({ color: "cat-blue", text: "Greenside", type: "Campus", origin });
    case "greenside  block a":
      return UIRender({ color: "cat-blue", text: "Greenside - Block A", type: "Campus", origin });
    case "greenside  block b":
      return UIRender({ color: "cat-blue", text: "Greenside - Block B", type: "Campus", origin });
    case "pretoria":
      return UIRender({ color: "cat-yellow", text: "Pretoria", type: "Campus", origin });
    case "midjohn":
      return UIRender({ color: "cat-yellowshade", text: "Midrand", type: "Campus", origin });
    case "midrand":
      return UIRender({ color: "cat-yellowshade", text: "Midrand", type: "Campus", origin });
    case "midrand campus":
      return UIRender({ color: "cat-yellowshade", text: "Midrand", type: "Campus", origin });
    case "midrand  block a":
      return UIRender({ color: "cat-yellowshade", text: "Midrand - Block A", type: "Campus", origin });
    case "midrand  block b":
      return UIRender({ color: "cat-yellowshade", text: "Midrand - Block B", type: "Campus", origin });
    case "midrand  block c":
      return UIRender({ color: "cat-yellowshade", text: "Midrand - Block C", type: "Campus", origin });
    case "midrand  block d":
      return UIRender({ color: "cat-yellowshade", text: "Midrand - Block D", type: "Campus", origin });
    case "cape campus":
      return UIRender({ color: "cat-yellowshade", text: "Cape", type: "Campus", origin });
    case "online":
      return UIRender({ color: "cat-yellow", text: "Online", type: "Campus", origin });
    case "hatfield":
      return UIRender({ color: "cat-lightgreen", text: "Hatfield", type: "Campus", origin });
    case "on site":
      return UIRender({ color: "cat-purple", text: "Hatfield", type: "Campus", origin });
    default:
      return UIRender({ color: "cat-black", text: "-", type: "Campus" });
  }
};

// This will only be used in Class type.
export const RenderUserRole = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "accounts":
    return UIRender({ color: "cat-red", text: "Accounts", type: "userRole", origin });
    case "admin":
    return UIRender({ color: "cat-skyblue", text: "Admin", type: "userRole", origin });
    case "content editor":
    return UIRender({ color: "cat-black", text: "Content Editor", type: "userRole", origin });
    case "developer":
    return UIRender({ color: "cat-red", text: "Developer", type: "userRole", origin });
    case "lecturer":
    return UIRender({ color: "cat-greenhex", text: "Lecturer", type: "userRole", origin });
    case "manager":
    return UIRender({ color: "cat-blue", text: "Manager", type: "userRole", origin });
    case "programme coordinator":
    return UIRender({ color: "cat-black", text: "Programme Coordinator", type: "userRole", origin });
    case "sales":
    return UIRender({ color: "cat-blue", text: "Sales", type: "userRole", origin });
    case "student support":
    return UIRender({ color: "cat-greenhex", text: "Student Support", type: "userRole", origin });
    case "student":
            return UIRender({color:'cat-blue', text: 'Student', type: 'userRole', origin});
    case "":
    return UIRender({ color: "cat-black", text: "N/A", type: "userRole", origin });
    case null:
    return UIRender({ color: "cat-black", text: "N/A", type: "userRole", origin });
    case undefined:
    return UIRender({ color: "cat-black", text: "N/A", type: "userRole", origin });
    default:
    return UIRender({ color: "cat-black", text: data, type: "userRole" });
  }
};

// This will only be used in user location.
export const RenderUserLocation = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "midrand":
    return UIRender({ color: "cat-red", text: "Midrand", type: "userLocation", origin });
    case "johannesburg":
    return UIRender({ color: "cat-skyblue", text: "Johannesburg", type: "userLocation", origin });
    case "cape town":
    return UIRender({ color: "cat-blue", text: "Cape Town", type: "userLocation", origin });
    case "hatfield":
    return UIRender({ color: "cat-pink", text: "Hatfield", type: "userLocation", origin });
    case "remote/online":
    return UIRender({ color: "cat-yellowshade", text: "Remote/Online", type: "userLocation", origin });
    default:
    return UIRender({ color: "cat-black", text: "N/A", type: "userLocation" });
  }
};

// This will only be used in user Company.
export const RenderUserCompany = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "academic institute of excellence (aie)":
    return UIRender({ color: "cat-red", text: "Academic Institute of Excellence (AIE)", type: "userCompany", origin });
    case "greenside design center (gdc)":
    return UIRender({ color: "cat-skyblue", text: "Greenside Design Center (GDC)", type: "userCompany", origin });
    case "learnfast":
    return UIRender({ color: "cat-blue", text: "Learnfast", type: "userCompany", origin });
    case "cadco":
    return UIRender({ color: "cat-red", text: "Cadco", type: "userCompany", origin });
    default:
    return UIRender({ color: "cat-black", text: "N/A", type: "userCompany" });
  }
};

// This will only be used in user Company.
export const RenderAuditTrailActionType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "created":
    return UIRender({ color: "cat-blue", text: "Created", type: "auditTrailActionType", origin });
    case "edited":
    return UIRender({ color: "cat-greenhex", text: "Edited", type: "auditTrailActionType", origin });
    case "locked grades":
    return UIRender({ color: "cat-red", text: "Locked Grades", type: "auditTrailActionType", origin });
    case "unlocked grades":
    return UIRender({ color: "cat-greenhex", text: "Unlocked Grades", type: "auditTrailActionType", origin });
    case "deleted":
    return UIRender({ color: "cat-red", text: "Deleted", type: "auditTrailActionType", origin });
    case "profile picture edited":
    return UIRender({ color: "cat-yellowshade", text: "Picture Edited", type: "auditTrailActionType", origin });
    case "approved":
    return UIRender({ color: "cat-greenhex", text: "Approved", type: "auditTrailActionType", origin });
    case "declined":
    return UIRender({ color: "cat-red", text: "Declined", type: "auditTrailActionType", origin });
    case "imported":
    return UIRender({ color: "cat-yellowshade", text: "Imported", type: "auditTrailActionType", origin });
    case "uploaded":
    return UIRender({ color: "cat-yellowshade", text: "Uploaded", type: "auditTrailActionType", origin });
    case "logged in (desktop)":
    return UIRender({ color: "cat-yellowshade", text: "Logged In (Desktop)", type: "auditTrailActionType", origin });
    case "logged out (desktop)":
    return UIRender({ color: "cat-lightblue", text: "Logged Out (Desktop)", type: "auditTrailActionType", origin });
    case "logged in (mobile)":
    return UIRender({ color: "cat-blue", text: "Logged In (Mobile)", type: "auditTrailActionType", origin });
    case "logged out (mobile)":
    return UIRender({ color: "cat-yellow", text: "Logged Out (Mobile)", type: "auditTrailActionType", origin });
    case "read ticket":
    return UIRender({ color: "cat-blueshade", text: "Read Ticket", type: "auditTrailActionType", origin });
    case "replied to ticket":
    return UIRender({ color: "cat-pink", text: "Replied to Ticket", type: "auditTrailActionType", origin });
    case "opened resource":
    return UIRender({ color: "cat-brown", text: "Opened Resource", type: "auditTrailActionType", origin });
    case "read notification":
    return UIRender({ color: "cat-red", text: "Read Notification", type: "auditTrailActionType", origin });
    case 'submitted assessment':
    return UIRender({ color: 'cat-green', text: 'Submitted Assessment', type: 'auditTrailActionType', origin })
    case 'submitted assessment (desktop)':
    return UIRender({ color: 'cat-green', text: 'Submitted Assessment  (Desktop)', type: 'auditTrailActionType', origin });
    case 'submitted assessment (mobile)':
    return UIRender({ color: 'cat-light-green', text: 'Submitted Assessment  (Mobile)', type: 'auditTrailActionType', origin });
    case 'launched assessment (desktop)':
    return UIRender({ color: 'cat-yellowshade', text: 'Launched Assessment (Desktop)', type: 'auditTrailActionType', origin });
    case 'launched assessment (mobile)':
    return UIRender({ color: 'cat-blue', text: 'Launched Assessment (Mobile)', type: 'auditTrailActionType', origin });
    case "declined":
    return UIRender({ color: "cat-skyblue", text: "Declined", type: "auditTrailActionType", origin });
    case "re-registration new":
    return UIRender({ color: "cat-yellowshade", text: "Re-Registration New", type: "auditTrailActionType", origin });
    case "remind me later":
    return UIRender({ color: "cat-greenhex", text: "Remind Me Later", type: "auditTrailActionType", origin });
    case "exam registration":
    return UIRender({ color: "cat-lightblue", text: "Exam Registration", type: "auditTrailActionType", origin });
    case "rejected":
    return UIRender({ color: "cat-orange", text: "Rejected", type: "auditTrailActionType" });
    case "marked as final":
    return UIRender({ color: "cat-purple", text: "Marked as Final", type: "auditTrailActionType" });
    case "merged":
    return UIRender({ color: "cat-skyblue", text: "Merged", type: "auditTrailActionType" });
    case "set to accounts":
    return UIRender({ color: "cat-brown", text: "Set To Accounts", type: "auditTrailActionType" });
    case "posted to netsuite":
    return UIRender({ color: "cat-blue", text: "Posted To Netsuite", type: "auditTrailActionType" });
    case "save & add to live portal clicked":
    return UIRender({ color: "cat-green", text: "Save & Add to Live Portal Clicked", type: "auditTrailActionType" });
    case "sent welcome letter":
    return UIRender({ color: "cat-green", text: "Sent Welcome Letter", type: "auditTrailActionType" });
    case "logged in (desktop)":
    return UIRender({ color: "cat-yellowshade", text: "Logged In (Desktop)", type: "auditTrailActionType" });
    case "logged out (desktop)":
    return UIRender({ color: "cat-lightblue", text: "Logged Out (Desktop)", type: "auditTrailActionType" });
    case "logged in (mobile)":
    return UIRender({ color: "cat-blue", text: "Logged In (Mobile)", type: "auditTrailActionType" });
    case "logged out (mobile)":
    return UIRender({ color: "cat-yellow", text: "Logged Out (Mobile)", type: "auditTrailActionType" });
    case "declined":
    return UIRender({ color: "cat-skyblue", text: "Declined", type: "auditTrailActionType" });
    case "opened resource":
    return UIRender({ color: "cat-brown", text: "Opened Resource", type: "auditTrailActionType" });
    case "re registration new":
    return UIRender({ color: "cat-yellowshade", text: "Re-Registration New", type: "auditTrailActionType" });
    case "read notification":
    return UIRender({ color: "cat-red", text: "Read Notification", type: "auditTrailActionType" });
    case "read ticket":
    return UIRender({ color: "cat-blueshade", text: "Read Ticket", type: "auditTrailActionType" });
    case "remind Me later":
    return UIRender({ color: "cat-greenhex", text: "Remind Me Later", type: "auditTrailActionType" });
    case "replied to ticket":
    return UIRender({ color: "cat-pink", text: "Replied to Ticket", type: "auditTrailActionType" });
    case "submitted assessment":
    return UIRender({ color: "cat-pinkshade", text: "Submitted Assessment", type: "auditTrailActionType" });
    case "online":
    return UIRender({ color: "cat-green", text: "Online", type: "auditTrailActionType" });
    case "offline":
    return UIRender({ color: "cat-red", text: "Offline", type: "auditTrailActionType" });
    case "logged in (ami phone)":
    return UIRender({ color: "cat-purple", text: "Logged In (AMI Phone)", type: "auditTrailActionType" });
    case "logged out (ami phone)":
    return UIRender({ color: "cat-missed", text: "Logged Out (AMI Phone)", type: "auditTrailActionType" });
    case "unlinked course":
    return UIRender({ color: "cat-red", text: "Unlinked Course", type: "auditTrailActionType" });
    case "linked course":
    return UIRender({ color: "cat-yellowshade", text: "Linked Course", type: "auditTrailActionType" });
    default:
    return UIRender({ color: "cat-black", text: data, type: "auditTrailActionType" });
  }
};

//only for Appeal Submission Status
export const RenderSubmissionStatus = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "appealpending":
    return UIRender({ color: "cat-yellow", text: "Appeal-Pending", type: "submissionStatus", origin });
    case "appealapproved":
    case "approved":
    return UIRender({ color: "cat-greenhex", text: "Appeal-Approved", type: "submissionStatus", origin });
    case "draft":
    return UIRender({ color: "cat-skyblue", text: "Draft", type: "submissionStatus", origin });
    case "marked":
    return UIRender({ color: "cat-green", text: "Marked", type: "submissionStatus", origin });
    case "not submitted":
    return UIRender({ color: "cat-yellowshade", text: "Not-Submitted", type: "submissionStatus", origin });
    case "submitted":
    return UIRender({ color: "cat-red", text: "Submitted", type: "submissionStatus", origin });
    case "closednot submitted":
    return UIRender({ color: "cat-dark-red", text: "Closed-Not Submitted", type: "submissionStatus", origin });
    default:
    return UIRender({ color: "cat-black", text: data, type: "submissionStatus" });
  }
};

//this will only be used course report -> attendance type
export const RenderAttendanceType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "virtual":
    return UIRender({ color: "cat-greenhex", text: "Virtual Classroom", type: "attendanceType", origin });
    case "on campus":
    return UIRender({ color: "cat-red", text: "On Campus Class", type: "attendanceType", origin });
    default:
    return UIRender({ color: "cat-black", text: data, type: "attendanceType" });
  }
};

//this will only be used for department.
export const RenderDepartment = (data, origin) => {
  let value = data.toString().toLowerCase().replace("-", " ")
  return UIRender({ color: stc(value), text: value, type: "department", origin });
};

export const RenderMenuType = (data, origin) => {
  switch (data) {
    case "Main Menu":
    return UIRender({ color: "cat-blueHead", text: "Main Menu", type: "menuType", origin });
    case 1:
    return UIRender({ color: "cat-blueHead", text: "Main Menu", type: "menuType", origin });
    case "Standard Menu":
    return UIRender({ color: "cat-greenhex", text: "Standard Menu", type: "menuType", origin });
    case "Footer Menu":
    return UIRender({ color: "cat-purple", text: "Footer Menu", type: "menuType", origin });
    case 2:
    return UIRender({ color: "cat-greenhex", text: "Standard Menu", type: "menuType", origin });
    case 3:
    return UIRender({ color: "cat-purple", text: "Footer Menu", type: "menuType", origin });
    case "Midrand":
    return UIRender({ color: "cat-purple", text: "Midrand", type: "menuType", origin });
    case "Midrand Campus":
    return UIRender({ color: "cat-purple", text: "Midrand", type: "menuType", origin });
    case "Cape Campus":
    return UIRender({ color: "cat-purple", text: "Cape Campus", type: "menuType", origin });
    case "School of Business, Entrepreneurship & Finance":
    return UIRender({ color: "cat-purple", text: "School of Business, Entrepreneurship & Finance", type: "menuType", origin });
    case "School of Artisans & Technical Trades":
    return UIRender({ color: "cat-purple", text: "School of Artisans & Technical Trades", type: "menuType", origin });
    case "School of Beauty & Health Science":
    return UIRender({ color: "cat-purple", text: "School of Beauty & Health Science", type: "menuType", origin });
    case "School of Engineering & Science":
    return UIRender({ color: "cat-purple", text: "School of Engineering & Science", type: "menuType", origin });
    case "School of Draughting & Technical Design":
    return UIRender({ color: "cat-purple", text: "School of Draughting & Technical Design", type: "menuType", origin });
    case "School of Information Technology & Data Science":
    return UIRender({ color: "cat-purple", text: "School of Information Technology & Data Science", type: "menuType", origin });
    default:
    return UIRender({ color: "cat-black", text: data, type: "menuType" });
  }
};

export const RenderType = (data, origin) => {
  switch (data) {
    default:
    return UIRender({ color: "cat-blue", text: data, type: "menuType" });
  }
};

//this will only be used for department.
export const RenderCategory = (data, origin) => {
  let value = data.toString().toLowerCase().replace("-", " ")
  return UIRender({ color: stc(value), text: value, type: "category", origin });
};

//Only used for version filter.
export const RenderVersion = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "v1":
    return UIRender({ color: "cat-skyblue", text: "V1", type: "versionFilter", origin });
    case "v2":
    return UIRender({ color: "cat-red", text: "V2", type: "versionFilter", origin });
    case "v3":
    return UIRender({ color: "cat-yellow", text: "V3", type: "versionFilter", origin });
    case "v4":
    return UIRender({ color: "cat-blue", text: "V4", type: "versionFilter", origin });
    case "v5":
    return UIRender({ color: "cat-greenhex", text: "V5", type: "versionFilter", origin });
    case "v6":
    return UIRender({ color: "cat-skyblue", text: "V6", type: "versionFilter", origin });
    case "v7":
    return UIRender({ color: "cat-red", text: "V7", type: "versionFilter", origin });
    case "v8":
    return UIRender({ color: "cat-yellow", text: "V8", type: "versionFilter", origin });
    case "v9":
    return UIRender({ color: "cat-blue", text: "V9", type: "versionFilter", origin });
    case "v10":
    return UIRender({ color: "cat-greenhex", text: "V10", type: "versionFilter", origin });
    default:
    return UIRender({ color: "cat-black", text: "N/A", type: "versionFilter" });
  }
};

//only for attendance health filter
export const RenderAttendanceHealth = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    
    case "critical":
    return UIRender({ color: "cat-red", text: "Critical", type: "attendanceHealth", origin });
    case "good":
    return UIRender({ color: "cat-green", text: "Good", type: "attendanceHealth", origin });
    case "moderate":
    return UIRender({ color: "cat-orange", text: "Moderate", type: "attendanceHealth", origin });
    default:
    return UIRender({ color: "cat-black", text: "N/A", type: "attendanceHealth" });
  }
};

//only for level for question
export const RenderQuestionLevel = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "easy":
    return UIRender({
      color: "cat-green",
      text: "Easy",
      type: "questionLevel",
    });
    case "hard":
    return UIRender({
      color: "cat-red",
      text: "Hard",
      type: "questionLevel",
    });
    case "medium":
    return UIRender({
      color: "cat-blue",
      text: "Medium",
      type: "questionLevel",
    });
    default:
    return UIRender({
      color: "cat-black",
      text: "-",
      type: "questionLevel",
    });
  }
};

//only for result for question
export const RenderResult = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "green":
    return UIRender({
      color: "cat-green",
      text: "Green",
      type: "questionLevel",
    });
    case "red":
    return UIRender({
      color: "cat-red",
      text: "Red",
      type: "questionLevel",
    });
    case "blue":
    return UIRender({
      color: "cat-blue",
      text: "Blue",
      type: "questionLevel",
    });
    case "yellow":
    return UIRender({
      color: "cat-yellow",
      text: "Yellow",
      type: "questionLevel",
    });
    default:
    return UIRender({
      color: "cat-black",
      text: "N/A",
      type: "questionLevel",
    });
  }
};

//only for question type
export const RenderQuestionType = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "multiple choice single answer":
    return UIRender({ icon: <i class="fal fa-tasks"></i>, color: "cat-yellow", text: "Multiple Choice Single Answer", type: "questionType" });
    case "multiple choice multiple answer":
    return UIRender({ icon: <i class="far fa-check-square"></i>, color: "cat-greenhex", text: "Multiple Choice Multiple Answer", type: "questionType" });
    case "match the column":
    return UIRender({ icon: <i class="far fa-line-columns" style="font-size: 24px;"></i>, color: "cat-light-pink", text: "Match the Column", type: "questionType" });
    case "short answer":
    return UIRender({ icon: <i class="far fa-comment-alt-lines"></i>, color: "cat-blue", text: "Short Answer", type: "questionType" });
    case "long answer":
    return UIRender({ icon: <i class="fal fa-align-left"></i>, color: "cat-red", text: "Long Answer", type: "questionType" });
    case "choice matrix":
    return UIRender({ icon: <i class="fal fa-table"></i>, color: "cat-light-green", text: "Choice Matrix", type: "questionType" });
    case "fill in the blank":
    return UIRender({ icon: <i class="far fa-keyboard"></i>, color: "cat-dark-blue", text: "Fill in the Blank", type: "questionType" });
    case "order list":
    return UIRender({ icon: <i class="fas fa-sort-numeric-down"></i>, color: "cat-extra-blue", text: "Order list", type: "questionType" });
    case "document upload":
    return UIRender({ icon: <i class="fal fa-file-upload"></i>, color: "cat-purple", text: "Document upload", type: "questionType" });
    case "evidence only":
    return UIRender({ icon: <i class="fal fa-check-square"></i>, color: "cat-check-square", text: "Evidence Only", type: "questionType" });
    default:
    return UIRender({ color: "cat-black", text: data, type: "questionType" });
  }
}

export const RenderEvidences = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "evidence_photo":
    return UIRender({ icon: <i class="fal fa-camera"></i>, color: "cat-black", text: "Photo", type: "evidenceType" });
    case "evidence_video":
    return UIRender({ icon: <i class="fal fa-video"></i>, color: "cat-black", text: "Video", type: "evidenceType" });
    case "evidence_lecturer_observation":
    return UIRender({ icon: <i class="fal fa-user-check"></i>, color: "cat-black", text: "Lecturer Observation", type: "evidenceType" });
    default:
    return UIRender({ color: "cat-black", text: data, type: "evidenceType" });
  }
}

//only for question type
export const RenderQuestionTypeForm = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "multiple choice single answer":
    return UIRender({ icon: <i class="fal fa-tasks"></i>, color: "cat-yellow", text: "Multiple Choice Single Answer", type: "questionTypeForm" });
    case "multiple choice multiple answer":
    return UIRender({ icon: <i class="far fa-check-square"></i>, color: "cat-greenhex", text: "Multiple Choice Multiple Answer", type: "questionTypeForm" });
    case "match the column":
    return UIRender({ icon: <i class="far fa-line-columns" style="font-size: 24px;"></i>, color: "cat-light-pink", text: "Match the Column", type: "questionTypeForm" });
    case "short answer":
    return UIRender({ icon: <i class="far fa-comment-alt-lines"></i>, color: "cat-blue", text: "Short Answer", type: "questionTypeForm" });
    case "long answer":
    return UIRender({ icon: <i class="fal fa-align-left"></i>, color: "cat-red", text: "Long Answer", type: "questionTypeForm" });
    case "choice matrix":
    return UIRender({ icon: <i class="fal fa-table"></i>, color: "cat-light-green", text: "Choice Matrix", type: "questionTypeForm" });
    case "fill in the blank":
    return UIRender({ icon: <i class="far fa-keyboard"></i>, color: "cat-dark-blue", text: "Fill in the Blank", type: "questionTypeForm" });
    case "order list":
    return UIRender({ icon: <i class="fas fa-sort-numeric-down"></i>, color: "cat-extra-blue", text: "Order list", type: "questionTypeForm" });
    case "document upload":
    return UIRender({ icon: <i class="fal fa-file-upload"></i>, color: "cat-purple", text: "Document upload", type: "questionTypeForm" });
    default:
    return UIRender({ color: "cat-black", text: data, type: "questionTypeForm" });
  }
}
//only for Resource Management Campus
export const RenderResourceCampus = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "centpre":
    return UIRender({ color: "cat-yellow", text: "Centurion, Pretoria", icon: "fa-university", type: "resourceCampus" });
    case "capetown":
    return UIRender({ color: "cat-greenhex", text: "Cape Town", icon: "fa-university", type: "resourceCampus" });
    case "midjohn":
    return UIRender({ color: "cat-skyblue", text: "Midrand", icon: "fa-university", type: "resourceCampus" });
    case "online":
    return UIRender({ color: "cat-blue", text: "Online", icon: "fa-wifi", type: "resourceCampus" });
    case "gdc":
    return UIRender({ color: "cat-brown", text: "Greenside", icon: "fa-university", type: "resourceCampus" });
    case "correspondence":
    return UIRender({ color: "cat-red", text: "Correspondence", icon: "fa-university", type: "resourceCampus" });
    case "2":
    return UIRender({ color: "cat-greenhex", text: "Cape Town", icon: "fa-university", type: "resourceCampus" });
    case "1":
    return UIRender({ color: "cat-skyblue", text: "Midrand, Block A", icon: "fa-university", type: "resourceCampus" });
    case "4":
    return UIRender({ color: "cat-blue", text: "Online", icon: "fa-wifi", type: "resourceCampus" });
    case "3":
    return UIRender({ color: "cat-brown", text: "Greenside, Block A", icon: "fa-university", type: "resourceCampus" });
    case "8":
    return UIRender({ color: "cat-greenhex", text: "Greenside, Block B", icon: "fa-university", type: "resourceCampus" });
    case "9":
    return UIRender({ color: "cat-skyblue", text: "Midrand, Block B", icon: "fa-university", type: "resourceCampus" });
    case "10":
    return UIRender({ color: "cat-skyblue", text: "Midrand, Block C", icon: "fa-university", type: "resourceCampus" });
    default:
    return UIRender({ color: "cat-black", text: data, type: "resourceCampus" });
  }
};

export const RenderSClassType = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "on_campus":
    return UIRender({
      color: "cat-blue",
      text: "On-campus",
      type: "classType",
    });
    case "hybrid":
    return UIRender({
      color: "cat-yellow",
      text: "Hybrid",
      type: "classType",
    });
    case "bbb_class":
    return UIRender({
      color: "cat-green",
      text: "Virtual",
      type: "classType",
    });
    default:
    return UIRender({ color: "black", text: "N/A", type: "classType" });
  }
};

// If any change is required then add condition on type, type will return which function called UIRender
export const UIRender = ({ color, text, type, backgroundColorHex, colorHex, origin, icon, key }) => {
  // Schools carry a brand hex rather than a cat-* class.
  if (type === "school") {
    return {
      color,
      text,
      html: (
        <span className="ui-element cat" style={{ color }} title={text}>
        {text !== "--" && <i className="fas fa-circle mr-1"></i>} {origin ? <span className='textLimit100'>{text}</span> : text}
        </span>
      ),
    };
  }
  if (type == "questionType") {
    return {
      color,
      text,
      icon,
      html: (
        <div className='d-flex' title={text}>
        <span className={"cat istyle " + color}>{text !== "-" && <i className={icon?.props?.class + " " + "mr-1"}></i>}</span>
        {origin ? <span className='textLimit100'>{text}</span> : text}
        </div>
      ),
    }
  }
  if (type == "evidenceType") {
    return {
      color,
      text,
      icon,
      html: (
        <div className='d-flex'>
        <span className={"cat istyle " + color}>{text !== "-" && <i className={`${icon?.props?.class} mr-1`}></i>}</span>
        {origin ? <span className='textLimit100'>{text}</span> : text}
        </div>
      ),
    }
  }
  if (type == "subjectItems" || type == "studentListFilter") {
    return {
      color,
      text,
      icon,
      html: (
        <div className='d-flex items cat'>
        <span className={"cat istyle " + color}>{text !== "-" && <i className={icon}></i>}</span>
        {origin ? <span className='textLimit100'>{text}</span> : text}
        </div>
      ),
    }
  }
  if (type == "LastLogin" || type == "pmcPageStatus") {
    return {
      
      text,
      html: (
        <div className='d-flex items cat'>
        {origin ? <span className='textLimit100'>{text}</span> : text}
        </div>
      ),
    }
  }
  if (type == "questionTypeForm") {
    return {
      color,
      text,
      icon,
      html: (
        <div className='d-flex'>
        {origin ? <span className='textLimit100'>{text}</span> : text}
        <span className={"cat ml-2 istyle " + color}>{text !== "-" && <i className={icon?.props?.class + " " + "mr-1"}></i>}</span>
        </div>
      ),
    }
  }
  if (type == "brandList" || type === "programme") {
    return {
      color,
      text,
      html: (
        <span className={"cat " + color} style={{ color }} title={text}>
          {text !== "-" && <i className="fas fa-circle mr-1"></i>} {origin ? <span className='textLimit100'>{text}</span> : text}
        </span>
      ),
    }
  }
  
  if (type == "resourceCampus") {
    return {
      color,
      text,
      html: (
        <span className={"cat " + color} title={text}>
        {text !== "-" && <i className={"fas " + icon + " " + "mr-1"}></i>} {origin ? <span className='textLimit100'>{text}</span> : text}
        </span>
      ),
    }
  }
  if (type == "department" || type == "category") {
    return {
      color,
      text,
      html: (
        <span className={"cat "} style={{ color, textTransform: "capitalize" }} title={text}>
        {text !== "-" && <i className="fas fa-circle mr-1"></i>} {origin ? <span className='textLimit100'>{text}</span> : text}
        </span>
      ),
    }
  }
  if (type == "header") {
    return {
      color,
      text,
      html: (
        <span className={"cat "} style={{ color, textTransform: "capitalize" }} title={text}>
        {text !== "-" && <i className="fas fa-circle mr-1"></i>} {origin ? <span className='textLimit100'>{text}</span> : text}
        </span>
      ),
    }
  }
  let bgColor = "", colorCode = "";
  if(type=='backgroundColorOnly'){
    return{
      color,
      text,
      bgColor,
      colorCode,
      html: (
        <span className={"cat " + color} title={text}>
        {origin ? <span className='textLimit100'>{text}</span> : text}
        </span>
      ),
    }
  }
  if (type == "pmcStatus" || type == "quiz") {
    bgColor = backgroundColorHex;
    colorCode = colorHex
  }
  return {
    color,
    text,
    bgColor,
    colorCode,
    html: (
      <span className={"ui-element cat " + color} title={text} key={text}>
      {text !== "-" && <i className="fas fa-circle mr-1"></i>} {origin ? <span className='textLimit100'>{text}</span> : text}
      </span>
    ),
  }
}

export const exportRegistrationStatus = (data) => {
  switch (data) {
    case "Re-Registration-Accounts":
    return "as-skyblue-bg as-widget";
    case "assign-subjects":
    return "as-red-bg as-widget";
    case "Closed-Ordered":
    return "as-red-bg as-widget";
    case "Closed-Ordered2":
    return "as-red-bg as-widget";
    case "Final-Status":
    return "as-yellow-bg as-widget";
    case "In-Active":
    return "as-yellow-bg as-widget";
    case "new-status":
    return "as-green-bg as-widget";
    case "Preliminary Re-Registration":
    return "as-green-bg as-widget";
    case "Re-Registration":
    return "as-yellow-bg as-widget";
    case "Re-Registration Cancelled":
    return "as-red-bg as-widget";
    case "Re-Registration Rejected":
    return "as-yellowshade-bg as-widget";
    case "Re-Registration-Accounts Rejected":
    return "as-green-bg as-widget";
    case "Re-Registration-Final":
    return "as-green-bg as-widget";
    case "Re-Registration-RCO":
    return "as-red-bg as-widget";
    case "Re-Registration-Sales":
    return "as-blue-bg as-widget";
    case "Re-Registration-Sales Admin":
    return "as-green-bg as-widget";
    case "Re-Registration-Sales Invoiced":
    return "as-red-bg as-widget";
    case "Re-Registration-Sales-Rejected":
    return "as-skyblue-bg as-widget";
    case "Re-Registration-Study Kit Pending":
    return "as-green-bg as-widget";
    case "Registration Withdrawn":
    return "as-yellowshade-bg as-widget";
    case "Rejected":
    return "as-blue-bg as-widget";
    case "Review":
    return "as-blue-bg as-widget";
  }
};

const CampusRender = ({ color, text, icon, type }) => {
  if (type == "dropdown") {
    return {
      color,
      text,
      html: (
        <span className='cat ' style={{ color: color ? color : "#000" }} title={text}>
        {(text !== "-" && text !== "") && <i className={"fas " + icon + " " + "mr-1"}></i>} {text}
        </span>
      )
    }
  } else {
    
  }
}

export const RenderCampusDropdown = (campus) => {
  switch (campus.label) {
    case "Online":
    return CampusRender({ color: campus.color, text: campus.label, icon: "fa-wifi", type: "dropdown" });
    case "online":
    return CampusRender({ color: campus.color, text: campus.label, icon: "fa-wifi", type: "dropdown" });
    default:
    return CampusRender({ color: campus.color, text: campus.label, icon: "fa-university", type: "dropdown" });
  }
}

// only for brand

export const RenderBrands = (label, color) => {
  return UIRender({ color: color, text: label, type: "brandList" });
}

/**
 * @param {number|string} brand_id or brand_name.
 */
export const getBrandUIData = (brand) => {
  switch (brand) {
    case BrandList.AIE.id:
    case BrandList.AIE.text:
      return { color: 'cat-blue', text: BrandList.AIE.text };
    case BrandList.GDC.id:
    case BrandList.GDC.text:
      return { color: 'cat-green', text: BrandList.GDC.text };
    case BrandList.LF.id:
    case BrandList.LF.text:
      return { color: 'cat-orange', text: BrandList.LF.text };
    case BrandList.EMI.id:
    case BrandList.EMI.text:
      return { color: 'cat-red', text: BrandList.EMI.text };
    case BrandList.CAD.id:
    case BrandList.CAD.text:
      return { color: 'cat-brown', text: BrandList.CAD.text };
    default:
      return { color: 'NA', text: BrandList.NONE.text };
  }
}

export const RenderBrandList = (brand) => {
  const { color, text } = getBrandUIData(brand);
  return UIRender({ origin: true, color, text, type: 'brandList' });
}

// only for programme or course type
export const RenderCertificateType = (data, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "course":
    return UIRender({ color: "cat-orange", text: "Course", type: "certificate", origin });
    case "subject":
    return UIRender({ color: "cat-orange", text: "Course", type: "certificate", origin });
    case "qualification":
    return UIRender({ color: "cat-blue", text: "Programme", type: "certificate", origin });
    case "qualifications":
    return UIRender({ color: "cat-blue", text: "Programme", type: "certificate", origin });
    case "grademix":
    return UIRender({ color: "cat-green", text: "GradeMix", type: "certificate", origin });
    case "programme gradebook setting":
    return UIRender({ color: "cat-skyblue", text: "Programme Gradebook Setting", type: "certificate" });
    case "notifications":
    return UIRender({ color: "cat-yellow", text: "Notifications", type: "certificate" });
    case "assign_subject":
    return UIRender({ color: "cat-red", text: "Assigned Subject", type: "certificate" });
    case "delete_assign_subject":
    return UIRender({ color: "cat-brown", text: "Delete Assigned Subject", type: "certificate" });
    case "not_applicable":
    return UIRender({ color: "cat-red", text: "Not Applicable", type: "certificate", origin });
    case "remove assigned subject":
    return UIRender({ color: "cat-purple", text: "Remove Assigned Subject", type: "certificate" });
    case "lock all grades":
      return UIRender({ color: "cat-red", text: "Lock All Grades", type: "resourceType" });
    case "unlock all grades":
      return UIRender({ color: "cat-greenhex", text: "Unlock All Grades", type: "resourceType" });
    case "unlock grades":
      return UIRender({ color: "cat-greenhex", text: "Unlock Grades", type: "resourceType" });
    case "lock grades":
      return UIRender({ color: "cat-red", text: "Lock Grades", type: "resourceType" });
    default:
    return UIRender({ color: "NA", text: "-", type: "certificate" });
  }
};

/**
 * Converts a given string into Title Case.
 * @param {string} str - The input string to be converted. Example: "hello world" → "Hello World"
 */
const toTitleCase = (str) => {
  return str
    ?.toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// only for Audit Trail Resource type
const resourceMap = {
  assemblies: { color: "cat-orange", text: "Assemblies" },
  assembly: { color: "cat-orange", text: "Assembly" },
  assesment: { color: "cat-blue", text: "Assesment" },
  assigned_program: { color: "cat-red", text: "Assigned Program" },
  course: { color: "cat-purple", text: "Course" },
  "course gradebook setting": { color: "cat-skyblue", text: "Course Gradebook Setting" },
  notification: { color: "cat-yellow", text: "Notification" },
  onlineclass: { color: "cat-greenhex", text: "Online Class" },
  submission: { color: "cat-brown", text: "Submission" },
  "template assigned": { color: "cat-green", text: "Certificate Assigned" },
  "certificate assigned": { color: "cat-green", text: "Certificate Assigned" },
  "marked question student": { color: "cat-green", text: "Marked Question Student" },
  "certificate generated": { color: "cat-greenhex", text: "Certificate Generated" },
  "question feedback": { color: "cat-yellow", text: "Question Feedback" },
  "marked student": { color: "cat-purple", text: "Marked Student" },
  "course bookings": { color: "cat-greenhex", text: "Course Bookings" },
  "lock all grades": { color: "cat-red", text: "Lock All Grades" },
  "unlock all grades": { color: "cat-greenhex", text: "Unlock All Grades" },
  "unlock grades": { color: "cat-greenhex", text: "Unlock Grades" },
  "lock grades": { color: "cat-red", text: "Lock Grades" },
  "assign module": { color: "cat-yellow", text: "Assign Module" },
  "features & benefit": { color: "cat-purple", text: "Features & Benefit" },
  "grade setting": { color: "cat-skyblue", text: "Grade Setting" },
  "linked programme": { color: "cat-pinkshade", text: "Linked Programme" },
  "pmc programme gradebook": { color: "cat-orange", text: "PMC Programme Gradebook" },
  programme: { color: "cat-skyblue", text: "Programme" },
  "removed module": { color: "cat-red", text: "Removed Module" },
  "study path": { color: "at-blue", text: "Study Path" },
  "unlinked programme": { color: "cat-red", text: "Unlinked Programme" },
  outcomes: { color: "cat-blue", text: "Outcomes" },
  topics: { color: "cat-brown", text: "Topics" },
  "version gradebook setting": { color: "cat-skyblue", text: "Version Gradebook Setting" },
  "short course resources": { color: "cat-green", text: "Short Course Resources" },
  version: { color: "cat-orange", text: "Version" },
  "programme software used": { color: "cat-gray", text: "Programme Software Used" },
  "progamme software used": { color: "cat-gray", text: "Programme Software Used" }, // typo variant
  "removed features & benefit": { color: "cat-red", text: "Removed Features & Benefit" },
  "programme dates": { color: "cat-gray", text: "Programme Dates" },
  "programme resources": { color: "cat-green", text: "Programme Resources" },
};
/**
 * Renders the resource type for audit trail records.
 * @param {string} resourceValue - The resource value associated with the audit trail entry.
* @returns {JSX.Element} Rendered UI element for the given resource type.
*/
export const RenderAuditTrailResourceType = (resourceValue) => {
  const formattedValue = resourceValue ? resourceValue.toString().replace(/-/g, "").toLowerCase().trim() : "";
  const resource = resourceMap[formattedValue];

  return UIRender({
    color: resource?.color || "cat-black",
    text: resource?.text || (resourceValue ? toTitleCase(resourceValue) : "-"),
    type: "resourceType",
  });
};



// only for Course Resource type
export const RenderCourseResourceType = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "assemblies":
    return UIRender({
      color: "cat-orange",
      text: "Assemblies",
      type: "resourceType",
    });
    case "assembly":
    return UIRender({
      color: "cat-orange",
      text: "Assembly",
      type: "resourceType",
    });
    case "assesment":
    return UIRender({
      color: "cat-blue",
      text: "Assesment",
      type: "resourceType",
    });
    case "assigned_program":
    return UIRender({
      color: "cat-red",
      text: "Assigned Program",
      type: "resourceType",
    });
    case "course":
    return UIRender({
      color: "cat-green",
      text: "Course",
      type: "resourceType",
    });
    case "course gradebook setting":
    return UIRender({
      color: "cat-skyblue",
      text: "Course Gradebook Setting",
      type: "resourceType",
    });
    case "notification":
    return UIRender({
      color: "cat-yellow",
      text: "Notification",
      type: "resourceType",
    });
    case "onlineclass":
    return UIRender({
      color: "cat-greenhex",
      text: "Online Class",
      type: "resourceType",
    });
    case "submission":
    return UIRender({
      color: "cat-brown",
      text: "Submission",
      type: "resourceType",
    });
    case "template assigned":
    return UIRender({
      color: "cat-green",
      text: "Certificate Assigned",
      type: "resourceType",
    });
    case "certificate assigned":
    return UIRender({
      color: "cat-green",
      text: "Certificate Assigned",
      type: "resourceType",
    });
    case "marked question student":
    return UIRender({
      color: "cat-green",
      text: "Marked Question Student",
      type: "resourceType",
    });
    case "certificate generated":
    return UIRender({
      color: "cat-greenhex",
      text: "Certificate Generated",
      type: "resourceType",
    });
    case "question feedback":
    return UIRender({
      color: "cat-yellow",
      text: "Question Feedback",
      type: "resourceType",
    });
    case "marked student":
    return UIRender({
      color: "cat-purple",
      text: "Marked Student",
      type: "resourceType",
    });
    case "course bookings":
    return UIRender({
      color: "cat-greenhex",
      text: "Course Bookings",
      type: "resourceType",
    });
    case "lock all grades":
      return UIRender({
        color: "cat-red",
        text: "Lock All Grades",
        type: "resourceType",
      });
    case "unlock all grades":
      return UIRender({
        color: "cat-greenhex",
        text: "Unlock All Grades",
        type: "resourceType",
      });
    case "unlock grades":
      return UIRender({
        color: "cat-greenhex",
        text: "Unlock Grades",
        type: "resourceType",
      });
    case "lock grades":
      return UIRender({
        color: "cat-red",
        text: "Lock Grades",
        type: "resourceType",
      });
    case "class_attendance":
      return UIRender({
        color: "cat-red",
        text: "Class Attendance",
        type: "resourceType",
      });
    default:
    return UIRender({ color: "NA", text: "-", type: "resourceType" });
  }
};

// only for Student Resource type
export const RenderStudentResourceType = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "logout_and_login":
    return UIRender({ color: "cat-orange", text: "Logout and Login", type: "resourceType" });
    case "exams_registrations":
    return UIRender({ color: "cat-lightblue", text: "Exam Registration", type: "resourceType" });
    case "re_registrations":
    return UIRender({ color: "cat-blue", text: "Re-Registrations", type: "resourceType" });
    case "logged in":
    return UIRender({ color: "cat-red", text: "Logged in", type: "resourceType" });
    case "logged out":
    return UIRender({ color: "cat-green", text: "Logged out", type: "resourceType" });
    case "reregistration declined":
    return UIRender({ color: "cat-skyblue", text: "Re-Registration Declined", type: "resourceType" });
    case "not yet registered":
    return UIRender({ color: "cat-yellow", text: "Not Yet Registered", type: "resourceType" });
    case "reregistration new":
    return UIRender({ color: "cat-greenhex", text: "Re-Registration New", type: "resourceType" });
    case "reregistration declined":
    return UIRender({ color: "cat-brown", text: "Re-registration Declined", type: "resourceType" });
    case "assessment":
    return UIRender({ color: "cat-greenhex", text: "Assessment", type: "resourceType" });
    case "articulationregistration declined":
    return UIRender({ color: "cat-pink", text: "Articulation-registration Declined", type: "resourceType" });
    case "articulationregistration":
    return UIRender({ color: "cat-dark-red", text: "Articulation-Registration", type: "resourceType" });
    case "reffering to student hub resources":
    return UIRender({ color: "cat-yellowshade", text: "Referring to Student Hub resources", type: "resourceType" });
    case "notification":
    return UIRender({ color: "cat-purple", text: "Notification", type: "resourceType" });
    case "reregistration":
    return UIRender({ color: "cat-blueshade", text: "Re-Registration", type: "resourceType" });
    case "general_info":
    return UIRender({ color: "cat-pinkshade", text: "General Info", type: "resourceType" });
    case "personal_info":
    return UIRender({ color: "cat-blueshade", text: "Personal Info", type: "resourceType" });
    case "student_note":
    return UIRender({ color: "cat-purple", text: "Student Note", type: "resourceType" });
    case "courseandprogram":
    return UIRender({ color: "cat-yellowshade", text: "Course And Program", type: "resourceType" });
    case "account_payer_info":
    return UIRender({ color: "cat-dark-red", text: "Account Payer Info", type: "resourceType" });
    case "education_details":
    return UIRender({ color: "cat-pink", text: "Education Details", type: "resourceType" });
    case "certificates":
    return UIRender({ color: "cat-greenhex", text: "Certificates", type: "resourceType" });
    case "personal_doc":
    return UIRender({ color: "cat-brown", text: "Personal Document", type: "resourceType" });
    case "student":
    return UIRender({ color: "cat-yellow", text: "Student", type: "resourceType" });
    case "notifications":
    return UIRender({ color: "cat-skyblue", text: "Notifications", type: "resourceType" });
    case "confirmation_letter":
    return UIRender({ color: "cat-green", text: "Confirmation Letter", type: "resourceType" });
    case "metric_certificate":
    return UIRender({ color: "cat-blue", text: "Metric Certificate", type: "resourceType" });
    
    default:
    return UIRender({ color: "cat-black", text: data, type: "resourceType" });
  }
};

// only for Certificate Template Resource type
export const RenderCertificateResourceType = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case "certificate":
    return UIRender({
      color: "cat-orange",
      text: "Certificate",
      type: "certificateResourceType",
    });
    
    default:
    return UIRender({
      color: "cat-black",
      text: data,
      type: "certificateResourceType",
    });
  }
};


//Only for subject Items and studentList columns show
export const RenderSubjectItems = (data, key) => {
  switch (key) {
    case "timetable":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Timetable", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Timetable", type: "subjectItems" })
    case "chatroom":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Chatroom", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Chatroom", type: "subjectItems" })
    case "details":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Details", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Details", type: "subjectItems" })
    case "content":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Content", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Content", type: "subjectItems" })
    case "genderDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Study Guide", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Study Guide", type: "subjectItems" })
    case "studentCard":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Study Guide", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Study Guide", type: "subjectItems" })
    case "nationalityDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Study Guide", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Study Guide", type: "subjectItems" })
    case "idPassportDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Study Guide", type: "subjectItems" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Study Guide", type: "subjectItems" })
    default:
    return "";
  }
};

//Only for subject Items filter
export const RenderSubjectItemsFilter = (data) => {
  switch (data) {
    case "timeTableTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Timetable", type: "subjectItems" })
    case "timeTableFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Timetable", type: "subjectItems" })
    case "chatroomTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Chatroom", type: "subjectItems" })
    case "chatroomFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Chatroom", type: "subjectItems" })
    case "detailsTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Details", type: "subjectItems" })
    case "detailsFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Details", type: "subjectItems" })
    case "contentTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Content", type: "subjectItems" })
    case "contentFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Content", type: "subjectItems" })
    default:
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: data, type: "subjectItems" })
  }
};


//Only for studentList columns items QA View show
export const RenderStudentListItems = (data, type) => {
  switch (type) {
    case "genderDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Gender", type: "studentListFilter" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Gender", type: "studentListFilter" })
    case "studentCard":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Generated", type: "studentListFilter" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Generated", type: "studentListFilter" })
    case "nationalityDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Nationality", type: "studentListFilter" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Nationality", type: "studentListFilter" })
    case "idPassportDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "ID/Passport", type: "studentListFilter" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "ID/Passport", type: "studentListFilter" })
    case "raceDemoGrapchic":
    return data === 1 || data === true
    ? UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Race", type: "studentListFilter" })
    : UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Race", type: "studentListFilter" })
    default:
    return "";
  }
};


//Only for subject Items filter QA View
export const RenderStudentListItemFilter = (data) => {
  switch (data) {
    case "NationalityTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Nationality", type: "studentListFilter" })
    case "NationalityFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Nationality", type: "studentListFilter" })
    case "generatedTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Generated", type: "studentListFilter" })
    case "generatedFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Generated", type: "studentListFilter" })
    case "genderTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Gender", type: "studentListFilter" })
    case "genderFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Gender", type: "studentListFilter" })
    case "IDPassportTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "ID/Passport", type: "studentListFilter" })
    case "IDPassportFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "ID/Passport", type: "studentListFilter" })
    case "raceTrue":
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Race", type: "studentListFilter" })
    case "raceFalse":
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "Race", type: "studentListFilter" })
    default:
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: data, type: "studentListFilter" })
  }
};

export const RenderLastLogin = (data) => {
  switch (data) {
    case "0":
    return UIRender({ text: "No first login", type: "LastLogin" })
    case "1":
    return UIRender({ text: "Last login within the past week", type: "LastLogin" })
    case "2":
    return UIRender({ text: "Last login within the past month", type: "LastLogin" })
    case "3":
    return UIRender({ text: "Last login within the past year", type: "LastLogin" })
    case "4":
    return UIRender({ text: "Last login over 1 year ago", type: "LastLogin" })
    
    default:
    return UIRender({ text: data, type: "LastLogin" })
  }
};

//programme credits

export const RenderCredits = (data) => {
  switch (data) {
    case 0:
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "No credit", type: "studentListFilter" })
    case 1:
    return UIRender({ icon: "fal fa-check check-true", color: "cat-green", text: "Credit Bearing", type: "studentListFilter" })
    default:
    return UIRender({ icon: "fal fa-times no-cross", color: "cat-red", text: "-", type: "studentListFilter" })
  }
};

//Programme Level
export const RenderProgrammeLevel = (data, origin) => {
  switch (data) {
    case 0:
    return UIRender({ color: "cat-gray", text: "None", type: "programme level", origin });
    case 1:
    return UIRender({ color: "cat-light-green", text: "Beginner", type: "programme level", origin });
    case 2:
    return UIRender({ color: "cat-light-blue", text: "Intermediate", type: "programme level", origin });
    case 3:
    return UIRender({ color: "cat-light-purple", text: "Advanced", type: "programme level", origin });
    case 4:
    return UIRender({ color: "cat-gray", text: "None", type: "programme level", origin });
    default:
    return UIRender({ color: "N/A", text: "-", type: "programme level", origin });
  }
};

export const IconUIRender = ({ color, text, icon }) => {
  return {
    color,
    text,
    html: (<span title={text} style={{ color: color }}><i className={`fal ${icon}`}></i> {text}</span>),
    iconOnly: (<span style={{ color: color }}><i className={`fal ${icon}`}></i></span>)
  }
}

export const RenderFileType = (data) => {
  const type = data.toString().toLowerCase();
  switch (type) {
    case ".png":
    return IconUIRender({ color: "#00B7C3", text: "PNG", icon: "fa-file-image" })
    case ".pdf":
    return IconUIRender({ color: "#F40F02", text: "PDF", icon: "fa-file-pdf" })
    case ".doc":
    return IconUIRender({ color: "#2B579A", text: "DOC", icon: "fa-file-word" })
    case ".jpg":
    return IconUIRender({ color: "#00B7C3", text: "JPG", icon: "fa-file-image" })
    case ".xlxs":
    return IconUIRender({ color: "#217346", text: "XLXS", icon: "fa-file-excel" })
    case ".wmv":
    return IconUIRender({ color: "#CA5010", text: "WMV", icon: "fa-file-video" })
    case ".zip":
    return IconUIRender({ color: "#7A7574", text: "ZIP", icon: "fa-file-archive" })
    case ".rar":
    return IconUIRender({ color: "#7A7574", text: "RAR", icon: "fa-file-archive" })
    case ".mp4":
    return IconUIRender({ color: "#CA5010", text: "MP4", icon: "fa-file-video" })
    case ".xls":
    return IconUIRender({ color: "#217346", text: "XLS", icon: "fa-file-excel" })
    case ".docx":
    return IconUIRender({ color: "#2B579A", text: "DOCX", icon: "fa-file-word" })
    case ".csv":
    return IconUIRender({ color: "#217346", text: "CSV", icon: "fa-file-excel" })
    case ".txt":
    return IconUIRender({ color: "#4F6BED", text: "TXT", icon: "fa-file-alt" })
    case ".html":
    return IconUIRender({ color: "#00AD56", text: "HTML", icon: "fa-file-code" })
    case ".vsdx":
    return IconUIRender({ color: "#4F6BED", text: "VSDX", icon: "fa-file-alt" })
    case ".webp":
    return IconUIRender({ color: "#00AD56", text: "WEBP", icon: "fa-file-code" })
    case ".ppt":
    return IconUIRender({ color: "#B7472A", text: "PPT", icon: "fa-file-powerpoint" })
    case ".mp3":
    return IconUIRender({ color: "#5C2E91", text: "PPT", icon: "fa-file-music" })
    
    default:
    return IconUIRender({ color: "#4F6BED", text: type, icon: "fa-file" })
  }
}
export const RenderBrandTemplate = (id) => {
  switch (id?.toString()) {
    case "2":
    return UIRender({
      color: "cat-blue",
      text: "Academic Institute of Excellence (AIE)",
      type: "brandList",
    });
    case "3":
    return UIRender({
      color: "cat-red",
      text: "Emendy Multimedia Institute",
      type: "brandList",
    });
    case "4":
    return UIRender({
      color: "cat-green",
      text: "Greenside Design Center (GDC)",
      type: "brandList",
    });
    case "5":
    return UIRender({
      color: "cat-orange",
      text: "LearnFast",
      type: "brandList",
    });
    case "6":
    return UIRender({
      color: "cat-brown",
      text: "The CAD Corporation",
      type: "brandList",
    });
    default:
    return UIRender({ color: "NA", text: "-", type: "brandList" });
  }
};
export const RenderMenuItemType = (data) => {
  switch (data) {
    case "Custom Link":
    return CampusRender({
      color: "#FB923C",
      text: data,
      icon: "fa-globe",
      type: "menuItem",
    });
    case "Sub-Menu":
    return CampusRender({
      color: "#22C55E",
      text: data,
      icon: "fa-indent",
      type: "menuItem",
    });
    case "Category Sub-Menu":
    return CampusRender({
      color: "#D946EF",
      text: data,
      icon: "fa-tag",
      type: "menuItem",
    });
    case "Column Divider":
    return CampusRender({
      color: "#14B8A6",
      text: data,
      icon: "fa-columns",
      type: "menuItem",
    });
    case "Static Heading":
    return CampusRender({
      color: "#818CF8",
      text: data,
      icon: "fa-heading",
      type: "menuItem",
    });
    case "Landing Page":
    return CampusRender({
      color: "#FB7185",
      text: data,
      icon: "fa-bookmark",
      type: "menuItem",
    });
    case "Standard Link Item":
    return CampusRender({
      color: "#FB7185",
      text: data,
      icon: "fa-bookmark",
      type: "menuItem",
    });
    default:
    return CampusRender({ text: data, icon: "-", type: "menuItem" });
  }
};
export const RenderPageTypeType = (data) => {
  switch (data) {
    case "Training Landing page":
    return CampusRender({
      color: "#14B8A6",
      text: data,
      icon: "fa-columns",
      type: "menuItem",
    });
    case "Static page":
    return CampusRender({
      color: "#818CF8",
      text: data,
      icon: "fa-heading",
      type: "menuItem",
    });
    case "Landing page":
    return CampusRender({
      color: "#FB7185",
      text: data,
      icon: "fa-bookmark",
      type: "menuItem",
    });
    case "Course page":
    return CampusRender({
      color: "#FB7185",
      text: data,
      icon: "fa-bookmark",
      type: "menuItem",
    });
    default:
    return CampusRender({ text: data, icon: "-", type: "menuItem" });
  }
};
export const RenderHeaderTypeMethod = (data, origin) => {
  switch (
    data
    ? data.toString().replace("-", "").replace(" ", "").toLowerCase()
    : ""
  ) {
    case "defaultheader":
    return UIRender({
      color: "#ABB072",
      text: "Default Header",
      type: "header",
      origin,
    });
    case "standardheader":
    return UIRender({
      color: "#00A9FF",
      text: "Standard Header",
      type: "header",
      origin,
    });
    
    default:
    return UIRender({
      color: "N/A",
      text: "-",
      type: "learning method",
      origin,
    });
  }
};
export const RenderHeaderPageType = (data, origin) => {
  switch (
    data
    ? data.toString().replace("-", "").replace(" ", "").toLowerCase()
    : ""
  ) {
    case "course":
    return UIRender({
      color: "#ABB072",
      text: "Course",
      type: "header",
      origin,
    });
    case "staticpage":
    return UIRender({
      color: "#5CB85C",
      text: "Static Page",
      type: "header",
      origin,
    });
    case "staticpage":
    return UIRender({
      color: "#5CB85C",
      text: "Static Page",
      type: "header",
      origin,
    });
    case "1":
    return UIRender({
      color: "#5CB85C",
      text: "Static Page",
      type: "header",
      origin,
    });
    case "landingpage":
    return UIRender({
      color: "#FFA800",
      text: "Landing Page",
      type: "header",
      origin,
    });
    case "eventlanding page":
    return UIRender({
      color: "#C12EF5",
      text: "Event Landing Page",
      type: "header",
      origin,
    });
    
    case "categorylanding page":
    return UIRender({
      color: "#007BFF",
      text: "Category Landing Page",
      type: "header",
      origin,
    });
    case "homepage":
    return UIRender({
      color: "#9747FF",
      text: "Home Page",
      type: "header",
      origin,
    });
    case "traininglanding page":
    return UIRender({
      color: "#9747FF",
      text: "Training Landing page",
      type: "header",
      origin,
    });
    case "3":
    return UIRender({
      color: "#9747FF",
      text: "Training Landing page",
      type: "header",
      origin,
    });
    case "courselanding page":
    return UIRender({
      color: "#C12EF5",
      text: "Course Landing Page",
      type: "header",
      origin,
    });
    
    default:
    return UIRender({
      color: "N/A",
      text: "-",
      type: "learning method",
      origin,
    });
  }
};

export const RenderCategoriesType = (data, origin) => {
  switch (
    data
    ? data.toString().replace("-", "").replace(" ", "").toLowerCase()
    : ""
  ) {
    case "school":
    return UIRender({
      color: "#007BFF",
      text: "School",
      type: "header",
      origin,
    });
    case "category":
    return UIRender({
      color: "#C12EF5",
      text: "Category",
      type: "header",
      origin,
    });
    default:
    return UIRender({
      color: "N/A",
      text: "-",
      type: "learning method",
      origin,
    });
  }
};

export const RenderPopupType = (data, origin) => {
  switch (
    data != null
    ? data.toString().replace("-", "").replace(" ", "").toLowerCase()
    : ""
  ) {
    case "category_landing_page":
    return UIRender({
      color: "#007BFF",
      text: "Category Landing Page",
      type: "header",
      origin,
    });
    case "categorylanding page":
    return UIRender({
      color: "#007BFF",
      text: "Category Landing Page",
      type: "header",
      origin,
    });
    case "short_course":
    return UIRender({
      color: "#EF8700",
      text: "Short Course",
      type: "header",
      origin,
    });
    case "1":
    return UIRender({
      color: "#EF8700",
      text: "Short Course",
      type: "header",
      origin,
    });
    case "programme":
    return UIRender({
      color: "#00A9FF",
      text: "Programme",
      type: "header",
      origin,
    });
    case 0 || "0":
    return UIRender({
      color: "#00A9FF",
      text: "Programme",
      type: "header",
      origin,
    });
    case "static_page":
    return UIRender({
      color: "#ABB072",
      text: "Static Page",
      type: "header",
      origin,
    });
    case "staticpage":
    return UIRender({
      color: "#ABB072",
      text: "Static Page",
      type: "header",
      origin,
    });
    case "course_landing_page":
    return UIRender({
      color: "#C12EF5",
      text: "Course Landing Page",
      type: "header",
      origin,
    });
    case "courselanding page":
    return UIRender({
      color: "#C12EF5",
      text: "Course Landing Page",
      type: "header",
      origin,
    });
    case "campus_landing_page":
    return UIRender({
      color: "#C12EF5",
      text: "Campus Landing Page",
      type: "header",
      origin,
    });
    case "campuslanding page":
    return UIRender({
      color: "#C12EF5",
      text: "Campus Landing Page",
      type: "header",
      origin,
    });
    case "blog_and_news_page":
    return UIRender({
      color: "#C12EF5",
      text: "blog And News Page",
      type: "header",
      origin,
    });
    case "blogandnews page":
    return UIRender({
      color: "#C12EF5",
      text: "blog And News Page",
      type: "header",
      origin,
    });
    case "eventlanding page":
    return UIRender({
      color: "#C12EF5",
      text: "Event Landing Page",
      type: "header",
      origin,
    });
    default:
    return UIRender({
      color: "N/A",
      text: "-",
      type: "learning method",
      origin,
    });
  }
};

export const RenderAssessmentTypeNew = (data, icon, origin) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {


    case "0":
      return NewAssignmentTypeIcon({ color: "cat-red", text: "External Exam", type: "AssessmentType", icon, origin });
    case "1":
      return NewAssignmentTypeIcon({ color: "cat-skyblue", text: "Assignment", type: "AssessmentType", icon, origin });
    case "2":
      return NewAssignmentTypeIcon({ color: "cat-green", text: "Internal Exam", type: "AssessmentType", icon, origin });
    case "3":
      return NewAssignmentTypeIcon({ color: "cat-brown", text: "Test", type: "AssessmentType", icon, origin });
    case "4":
      return NewAssignmentTypeIcon({ color: "cat-blue", text: "PoE-Formative", type: "AssessmentType", icon, origin });
    case "5":
      return NewAssignmentTypeIcon({ color: "cat-yellowshade", text: "PoE-Informal Activities", type: "AssessmentType", icon, origin });
    case "6":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "PoE-Summative", type: "AssessmentType", icon, origin });
    case "7":
      return NewAssignmentTypeIcon({ color: "cat-purple", text: "Survey", type: "AssessmentType", icon, origin });
    case "8":
      return NewAssignmentTypeIcon({ color: "cat-blueshade", text: "Supplementary Exam", type: "AssessmentType", icon, origin });
    case "9":
      return NewAssignmentTypeIcon({ color: "cat-greenhex", text: "Sick Test", type: "AssessmentType", icon, origin });
    case "10":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "KM Exam", type: "AssessmentType", icon, origin });
    case "11":
      return NewAssignmentTypeIcon({ color: "cat-red", text: "PM Exam", type: "AssessmentType", icon, origin });
    case "12":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "Special Exam", type: "AssessmentType", icon, origin });


    case "km exam":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "KM Exam", type: "AssessmentType", icon, origin });
    case "pm exam":
      return NewAssignmentTypeIcon({ color: "cat-red", text: "PM Exam", type: "AssessmentType", icon, origin });
    case "special exam":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "Special Exam", type: "AssessmentType", icon, origin });
    case "sick test":
      return NewAssignmentTypeIcon({ color: "cat-greenhex", text: "Sick Test", type: "AssessmentType", icon, origin });
    case "assignment":
      return NewAssignmentTypeIcon({ color: "cat-skyblue", text: "Assignment", type: "AssessmentType", icon, origin });
    case "external exam":
      return NewAssignmentTypeIcon({ color: "cat-red", text: "External Exam", type: "AssessmentType", icon, origin });
    case "internal exam":
      return NewAssignmentTypeIcon({ color: "cat-green", text: "Internal Exam", type: "AssessmentType", icon, origin });
    case "scheduled":
      return NewAssignmentTypeIcon({ color: "cat-green", text: "Scheduled", type: "course type", icon, origin });
    case "poeformative":
      return NewAssignmentTypeIcon({ color: "cat-blue", text: "PoE-Formative", type: "AssessmentType", icon, origin });
    case "survey":
      return NewAssignmentTypeIcon({ color: "cat-purple", text: "Survey", type: "AssessmentType", icon, origin });
    case "mentored":
      return NewAssignmentTypeIcon({ color: "cat-blue", text: "Mentored", type: "course type", icon, origin });
    case "poeinformal activities":
      return NewAssignmentTypeIcon({ color: "cat-yellowshade", text: "PoE-Informal Activities", type: "AssessmentType", icon, origin });
    case "information":
      return NewAssignmentTypeIcon({ color: "cat-red", text: "Information", type: "course type", icon, origin });
    case "test":
      return NewAssignmentTypeIcon({ color: "cat-brown", text: "Test", type: "AssessmentType", icon, origin });
    case "orientation":
      return NewAssignmentTypeIcon({ color: "cat-brown", text: "Orientation", type: "course type", icon, origin });
    case "supplementary exam":
      return NewAssignmentTypeIcon({ color: "cat-blueshade", text: "Supplementary Exam", type: "AssessmentType", icon, origin });
    case "shortcourse":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "Course", type: "course type", icon, origin });
    case "short course":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "Course", type: "course type", icon, origin });
    case "rereg_shortcourse":
      return NewAssignmentTypeIcon({ color: "cat-yellow", text: "Course", type: "course type", icon, origin });
    case "hybrid":
      return NewAssignmentTypeIcon({ color: "cat-pinkhex", text: "Hybrid", type: "AssessmentType", icon, origin });
    case "smart":
      return NewAssignmentTypeIcon({ color: "cat-blue-heptica", text: "Smart Assessment", type: "AssessmentType", icon, origin });
    case "document":
      return NewAssignmentTypeIcon({ color: "cat-green-nature", text: "Document", type: "AssessmentType", icon, origin });

    default:
      return NewAssignmentTypeIcon({ color: "cat-red", text: "External Exam", type: "AssessmentType", icon, origin });
  }
}

export const NewAssignmentTypeIcon = ({ color, text, type,icon, origin, usedType='row'}) => {
  const iconObject = {
    'hybrid' : 'fal fa-shapes',
    'smart' : 'fal fa-spell-check',
    'document' : 'fal fa-file-alt'
  }
  const colorObj = {
    'hybrid' : 'as-hybrid',
    'smart' : 'as-smart',
    'document' : 'as-document'
  }

  return {
    color,
    text,
    icon,
    html: (
      <div className={` ${usedType == 'filter' ? colorObj[icon] : color} d-flex align-items-center`}>
      <i className={` ${iconObject[icon]} ${usedType == 'filter' ? colorObj[icon] : color} mr-1`}></i>
        {origin ? <span className='textLimit100'>{text}</span> : text}
    </div>
    ),
  }
}

export const AssessmentMarkingMarkedFilter = (data) => {
  switch (data ? data.toString().replace("-", "").toLowerCase() : "") {
    case '1':
    return { html : <span className='as-green-bg as-widget'>MARKED</span>}
    case '0':
    return { html : <span className='as-red-bg as-widget'>NOT MARKED</span>}
  }
};
